import Slider from '@material-ui/core/Slider';
import React from 'react';
import styled from 'styled-components';
import { Color } from 'modules/styles/colors';
import { MuiBox, MuiLinearProgress } from 'theme/material-ui';

const StyledSlider = styled(Slider)`
  &.MuiSlider-root.Mui-disabled {
    color: ${Color.tealOriginal};
  }

  .MuiSlider-rail {
    opacity: 0.4;
  }

  .MuiSlider-thumb.Mui-disabled {
    width: 16px;
    height: 16px;
    border: 3px solid ${Color.foreColor};
    margin-top: -7px;
    margin-left: -7px;
  }

  .MuiSlider-mark {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    margin: -9px;
    border: 2px solid ${Color.turqoiseLight};
    color: ${Color.foreColor};

    &.MuiSlider-markActive {
      background-color: ${Color.tealOriginal};
      opacity: 1;
      border: ${Color.tealOriginal};
    }
  }
`;

const StyledLinearProgress = styled(MuiLinearProgress)`
  && {
    & .MuiLinearProgress-barColorPrimary {
      background-color: ${Color.turquoiseDarkBar};
    }
    background-color: ${Color.turquoiseLightBar};
    height: 14px;
  }
`;

export const ProgressStepper = ({ step }: { step: number }) => {
  const progress = Math.ceil((step / 5) * 100);
  return (
    <MuiBox>
      <StyledLinearProgress variant="determinate" value={progress} />
    </MuiBox>
  );
};
